import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheUrlService, HTTP_HEADERS } from '@improver/core';
import { isNil } from '@improver/shared/utils';
import { Observable, of } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Injectable()
export class HttpCacheUrlInterceptor implements HttpInterceptor {
  constructor(private cacheUrlService: CacheUrlService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isRequestCached(req)) {
      return of(this.cacheUrlService.getCachedData(req.urlWithParams)).pipe(take(1));
    }

    return next.handle(req).pipe(
      tap((data: any) => {
        if (this.shouldRequestBeCached(req)) {
          this.cacheUrlService.cache(req.urlWithParams, data);
        }
      })
    );
  }

  private shouldRequestBeCached(request: HttpRequest<any>): boolean {
    return !isNil(request.headers.get(HTTP_HEADERS.CACHE_URL));
  }

  private isRequestCached({ urlWithParams }: HttpRequest<any>): boolean {
    return this.cacheUrlService.getCachedData(urlWithParams) !== undefined;
  }
}
